import { createSvgIcon } from '@automata/mui-theme';
export const LiconicStoreXstx56Icon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41 25C41.5523 25 42 25.4477 42 26V79C42 79.5523 41.5523 80 41 80C40.4477 80 40 79.5523 40 79V26C40 25.4477 40.4477 25 41 25Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.402 9.04155C46.1939 8.5528 47.1916 8.54429 47.9917 9.01946L65.4817 19.4069C66.2402 19.8574 66.7051 20.6742 66.7051 21.5564V56.9424L69.3317 58.5956C70.0588 59.0532 70.5 59.8522 70.5 60.7114V71.5708C70.5 72.3237 70.142 73.0224 69.5513 73.4634V74.8675C69.5513 75.7619 69.0734 76.5882 68.2982 77.0343L52.6956 86.013C51.9237 86.4573 50.9737 86.4573 50.2018 86.013L34.2143 76.8128C34.0213 76.7018 33.8441 76.5655 33.6872 76.4075L33.5916 76.3112C33.2029 75.9198 32.958 75.4121 32.8907 74.8703L31.7071 74.1552C30.9579 73.7024 30.5 72.8908 30.5 72.0154V19.6343C30.5 18.7673 30.9492 17.9623 31.6869 17.5069L45.402 9.04155ZM46.7201 11.7534L33.5 19.9133V71.7334L34.675 72.4433C35.3408 72.8456 35.7745 73.5338 35.8573 74.2971L51.4487 83.2693L66.5513 74.5784V73.1107C66.5513 72.3577 66.9093 71.659 67.5 71.218V60.9875L64.8734 59.3343C64.1463 58.8766 63.7051 58.0776 63.7051 57.2185V21.841L46.7201 11.7534Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.6382 19.4929C31.9182 19.0169 32.5311 18.858 33.0072 19.138L49.5389 28.8625L52.0529 27.6055C52.5469 27.3585 53.1476 27.5587 53.3946 28.0527C53.6416 28.5467 53.4414 29.1474 52.9474 29.3943L50.5002 30.6179V83.9999C50.5002 84.5522 50.0524 84.9999 49.5002 84.9999C48.9479 84.9999 48.5002 84.5522 48.5002 83.9999V30.5719L31.9931 20.8618C31.5171 20.5818 31.3582 19.9689 31.6382 19.4929Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.6427 17.4854C34.9268 17.0118 35.5411 16.8583 36.0147 17.1424L52.9965 27.3315L63.9802 20.6457C64.452 20.3585 65.0672 20.5082 65.3544 20.98C65.6415 21.4517 65.4919 22.0669 65.0201 22.3541L54.0363 29.0399C53.4015 29.4263 52.6047 29.4288 51.9675 29.0465L34.9857 18.8574C34.5121 18.5733 34.3585 17.959 34.6427 17.4854ZM65.0002 51.9999C65.5525 51.9999 66.0002 52.4476 66.0002 52.9999V60.7767L68.004 59.6317C68.4836 59.3577 69.0944 59.5243 69.3684 60.0038C69.6424 60.4833 69.4758 61.0941 68.9963 61.3682L65.5077 63.3616L52.0211 71.55C51.4013 71.9262 50.6265 71.9376 49.9959 71.5798L32.0066 61.3696C31.5263 61.097 31.3579 60.4866 31.6305 60.0063C31.9031 59.526 32.5135 59.3576 32.9938 59.6302L50.9831 69.8404L64.0002 61.9372V52.9999C64.0002 52.4476 64.4479 51.9999 65.0002 51.9999Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M53 28C53.5523 28 54 28.4477 54 29V84C54 84.5523 53.5523 85 53 85C52.4477 85 52 84.5523 52 84V29C52 28.4477 52.4477 28 53 28Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.7321 73L44.7321 76.386L45.2679 76.6954L45.2679 73.3094L44.7321 73ZM43.866 70.5C43.3877 70.2239 43 70.4477 43 71L43 76.386C43 76.9383 43.3877 77.6098 43.866 77.886L46.134 79.1954C46.6123 79.4715 47 79.2477 47 78.6954L47 73.3094C47 72.7571 46.6123 72.0855 46.134 71.8094L43.866 70.5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35 64.5C35.5523 64.5 36 64.9477 36 65.5V70.5C36 71.0523 35.5523 71.5 35 71.5C34.4477 71.5 34 71.0523 34 70.5V65.5C34 64.9477 34.4477 64.5 35 64.5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38 67C38.5523 67 39 67.4477 39 68V73C39 73.5523 38.5523 74 38 74C37.4477 74 37 73.5523 37 73V68C37 67.4477 37.4477 67 38 67Z"
    />
  </svg>,
  'LiconicStoreXstx56Icon'
);
